import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";

import moment from "moment";

import { useClickOutside } from "./hooks";

import "./CalendarInput.scss";

import { DAYS_OF_WEEK, generateDates, dateToKey } from "./utils";

import CalendarInputDay from "./CalendarInputDay";
import CalendarInputHeader from "./CalendarInputHeader";

const CalendarInput = ({
  startDate = new Date(),
  data: initialState,
  weeks = 4,
  onChange = console.log
}) => {
  const calendar = useRef();
  const [state, setState] = useState({});

  useClickOutside(calendar, () => onChange(state));

  const [innerDate, setInnerDate] = useState(moment(startDate));

  const dates = useMemo(() => generateDates(innerDate, weeks), [
    innerDate,
    weeks
  ]);

  const handleChange = (day, value) => {
    const currState = { ...state, [dateToKey(day)]: value };
    const newState = Object.keys(currState).reduce(
      (acc, curr) =>
        currState[curr] ? { ...acc, [curr]: currState[curr] } : acc,
      {}
    );
    onChange(newState);
  };

  const handleSetMonth = dir => () => {
    setInnerDate(moment(innerDate).add(dir, "months"));
  };

  useEffect(() => {
    if (initialState) {
      setState(initialState);
    }
  }, [initialState]);

  return (
    <div className="calendar-input" ref={calendar}>
      <CalendarInputHeader date={innerDate} handleSetMonth={handleSetMonth} />
      <div className="calendar">
        {DAYS_OF_WEEK.map((d, i) => (
          <div className="calendar-day-label" key={i}>
            {d}
          </div>
        ))}
        {dates.map(d => (
          <CalendarInputDay
            day={moment(d)}
            key={dateToKey(d)}
            value={state[dateToKey(d)]}
            onChange={handleChange}
          />
        ))}
      </div>
    </div>
  );
};
CalendarInput.propTypes = {
  startDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(moment)
  ]),
  weeks: PropTypes.number,
  onChange: PropTypes.func,
  data: PropTypes.object
};

export default CalendarInput;
